import { Stack, getSpacing, markedForDeletionStyle, useTheme } from "@compass/core";
import { ReactNode } from "react";
import { SxProps, Theme } from "@mui/material";

export const InlineEditDataModel = (props: {
  content: ReactNode;
  actions: ReactNode;
  removing?: boolean;
  noPadding?: boolean;
  noBorder?: boolean;
  overflow?: "auto";
}) => {
  const theme = useTheme();
  const removingSx = props.removing ? markedForDeletionStyle(theme) : undefined;

  return (
    <Stack
      width="100%"
      direction="row"
      //bgcolor={(theme) => theme.palette.background.default}
      sx={{
        border: !props.noBorder ? (theme) => `1px solid ${theme.palette.border.dark}` : undefined,
      }}
    >
      <Stack
        flexGrow={1}
        // @ts-ignore
        sx={{
          ...removingSx,
          overflow: props.overflow ? props.overflow : undefined,
        }}
        p={!props.noPadding ? getSpacing("md") : undefined}
      >
        {props.content}
      </Stack>
      <Stack direction="row" alignItems="center" px={getSpacing("xs")}>
        {props.actions}
      </Stack>
    </Stack>
  );
};
